import { render, staticRenderFns } from "./frame_info.vue?vue&type=template&id=1339a4ba&scoped=true"
import script from "./frame_info.vue?vue&type=script&lang=js"
export * from "./frame_info.vue?vue&type=script&lang=js"
import style0 from "./frame_info.vue?vue&type=style&index=0&id=1339a4ba&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1339a4ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1339a4ba')) {
      api.createRecord('1339a4ba', component.options)
    } else {
      api.reload('1339a4ba', component.options)
    }
    module.hot.accept("./frame_info.vue?vue&type=template&id=1339a4ba&scoped=true", function () {
      api.rerender('1339a4ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appManage/frame_info.vue"
export default component.exports